module.exports = __webpack_public_path__ + "img/16581261_L.cd5ce5ac.png";